import styled from 'styled-components';

export const Close = styled.img`
  width: 32px;
  cursor: pointer;

  @media ${({ theme }) => theme.device.desktop} {
    top: 16px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.div`
  font-weight: bold;
`;
